import React, { useState } from "react";
import { firebaseAuth } from "../firebaseConfig";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { AuthButton, AuthContainer, AuthForm, Input } from "./form.style";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showSignUp, setShowSignUp] = useState(false);

  // Definieren Sie eine Liste von zugelassenen E-Mail-Adressen
  const allowedEmails = [
    "erikson@katapult-magazin.de",
    "m.shykolai@katapult-magazin.de",
    "redaktion@katapult-mv.de",
    "redaktion@katapult-magazin.de",
    "aboukraine@katapult-magazin.de",
    "mail@andreasbonke.de",
    "test@katapult-app.de",
    "hansen@katapult-magazin.de",
    "j.spijker@katapult-magazin.de",
    "appuser@katapult-magazin.de",
  ];

  const isEmailAllowed = (email) => {
    // Überprüfen Sie, ob die E-Mail mit einer der zugelassenen Domains endet
    return allowedEmails.includes(email);
  };

  const signUp = async (e) => {
    e.preventDefault();
    // Überprüfen Sie, ob die E-Mail erlaubt ist, bevor Sie fortfahren
    if (!isEmailAllowed(email)) {
      alert("Diese E-Mail-Adresse ist nicht zugelassen.");
      return;
    }
    try {
      await createUserWithEmailAndPassword(firebaseAuth, email, password);
    } catch (error) {
      alert("Fehler bei der Registrierung: " + error.message);
    }
    resetInputFields();
  };

  const signIn = async (e) => {
    e.preventDefault();
    // Überprüfen Sie, ob die E-Mail erlaubt ist, bevor Sie fortfahren
    if (!isEmailAllowed(email)) {
      alert("Diese E-Mail-Adresse ist nicht zugelassen.");
      return;
    }
    try {
      await signInWithEmailAndPassword(firebaseAuth, email, password);
    } catch (error) {
      alert("Fehler beim Anmelden:" + error.message);
    }
    resetInputFields();
  };

  const resetInputFields = () => {
    setEmail("");
    setPassword("");
  };

  return (
    <>
      {showSignUp ? (
        <AuthContainer>
          <AuthForm onSubmit={signUp}>
            <h2>Registrieren</h2>
            <Input
              type="email"
              placeholder="E-Mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="password"
              placeholder="Passwort"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <AuthButton type="submit">Registrieren</AuthButton>
          </AuthForm>
          <p>
            Bereits registriert?{" "}
            <span
              onClick={() => setShowSignUp(false)}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Jetzt anmelden
            </span>
          </p>
        </AuthContainer>
      ) : (
        <AuthContainer>
          <AuthForm onSubmit={signIn}>
            <h2>Anmelden</h2>
            <Input
              type="email"
              placeholder="E-Mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="password"
              placeholder="Passwort"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <AuthButton type="submit">Anmelden</AuthButton>
          </AuthForm>
          <p>
            Noch kein Konto?{" "}
            <span
              onClick={() => setShowSignUp(true)}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Jetzt registrieren
            </span>
          </p>
        </AuthContainer>
      )}
    </>
  );
};

export default Auth;
